// Axios client with token auto-attach. Endpoint URLs are the single source of truth.
import axios from 'axios';

const BASE = (import.meta.env && import.meta.env.BASE_URL) || '/';
const API_BASE = (BASE.endsWith('/') ? BASE : BASE + '/') + 'api';

const client = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('auth_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('auth_token');
    }
    return Promise.reject(err);
  }
);

export const endpoints = {
  auth: {
    signup:               '/auth/signup',
    login:                '/auth/login',
    logout:               '/auth/logout',
    me:                   '/auth/me',
    requestPasswordReset: '/auth/request-password-reset',
    resetPassword:        '/auth/reset-password',
    changePassword:       '/auth/me/change-password',
    verifyEmail: (t)  =>  `/auth/verify-email/${t}`,
    resendVerification:   '/auth/me/resend-verification',
    verifyUsername:       '/auth/verify-username',
    deleteSelf:           '/auth/me',
  },
  users: {
    list:                 '/users',
    setRole:    (id) =>   `/users/${id}/role`,
    suspend:    (id) =>   `/users/${id}/suspend`,
    remove:     (id) =>   `/users/${id}`,
    capabilities:(id)=>   `/users/${id}/capabilities`,
  },
  invites: {
    list:     '/invites',
    create:   '/invites',
    bulk:     '/invites/bulk',
    byToken:  (t) => `/invites/by-token/${t}`,
    accept:   '/invites/accept',
    decline:  (t) => `/invites/decline/${t}`,
    resend:   (id) => `/invites/${id}/resend`,
    revoke:   (id) => `/invites/${id}`,
  },
  roles: {
    list:           '/roles',
    create:         '/roles',
    update: (id) => `/roles/${id}`,
    remove: (id) => `/roles/${id}`,
    ensureSystem:   '/roles/ensure-system',
    capabilities:   '/roles/capabilities',
  },
  accessTokens: {
    list:           '/access-tokens',
    create:         '/access-tokens',
    revoke: (id) => `/access-tokens/${id}`,
    rotate: (id) => `/access-tokens/${id}/rotate`,
  },
  memberships:    '/memberships',
  membershipById: (id) => `/memberships/${id}`,
  leads:   '/leads',
  billing: { plans: '/billing/plans', checkout: '/billing/checkout' },
  analytics: { summary: '/analytics/summary', activity: '/analytics/activity' },
  admin: { seed: '/admin/seed-demo', system: '/admin/system' },
  questions: {
    list:       '/questions',
    get:        (slug) => `/questions/${slug}`,
    create:     '/questions',
    answer:     (slug) => `/questions/${slug}/answers`,
    vote:       (slug) => `/questions/${slug}/vote`,
    voteAnswer: (slug, aid) => `/questions/${slug}/answers/${aid}/vote`,
    accept:     (slug) => `/questions/${slug}/accept`,
  },
  articles: {
    list:    '/articles',
    get:     (slug) => `/articles/${slug}`,
    create:  '/articles',
    like:    (slug) => `/articles/${slug}/like`,
    comment: (slug) => `/articles/${slug}/comments`,
  },
};

export default client;
